/**
 * name 增加关键词指令
 * author zhang.yingyu
 * createTime 2019-04-08
 */
angular.module('addKeywordTipModule', [])
    .directive('addKeywordTip', ['$q', '$timeout',"modalDialog", function ($q, $timeout,modalDialog) {
        return {
            restrict: 'AE',
            replace: true,
            templateUrl: "./planningCenter/mediaLaboratory/directive/addKeywordTip/main_tpl.html",
            scope: {
                keywordArr: "=",
            },
            link: function ($scope, iElement, iAttrs) {
                initStatus();
                initData();
                /**
                 * [initStatus description]初始化状态
                 */
                function initStatus(){
                    $scope.status={
                       currentId:parseInt(Math.random()*10000),
                    };
                };
                /**
                 * [initData description]初始化数据
                 */
                function initData(){};
                /**
                 * [addTip description] 增加标签
                 */
                $scope.addTip=function(){
                    var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
                    if(regEn.test($scope.status.currentInp)) {
                        modalDialog.alertType('不能输入特殊字符', '', 'error', false, function() {});
                        $scope.status.currentInp='';
                        return;
                    }
                    if(!$scope.keywordIsRepeat($scope.status.currentInp.trim())&&$scope.status.currentInp!==""){
                        $scope.keywordArr.unshift($scope.status.currentInp.trim());
                        $scope.status.currentInp="";
                    }
                };
                $scope.pressAddTip=function(event){
                    if(event.keyCode===12||event.keyCode===32){
                        $scope.addTip();
                    }
                };
                /**
                 * [deleteKeywordTip description] 删除标签
                 */
                $scope.deleteKeywordTip=function(index){
                    $scope.keywordArr.splice(index, 1);
                }
                /**
                 * [keywordIsRepeat description]关键词是否重复
                 */
                $scope.keywordIsRepeat=function(value){
                    return $scope.keywordArr.indexOf(value) >=0 ?true:false;
                };
               $scope.changeKeyword=function(item,index){
                   $scope.keywordArr[index]=item;
               }
            }

        };
    }]);